import { LOGOUT, SET_ABSENCE_REASONS, SET_ABSENCE_LIST, SET_ABSENCE_HOURS_LIST, SET_ABSENCE_LIMITS } from "../actions/types";

const INITIAL_STATE = {
    reasons: [{
        absenceID: null,
        code: null,
        symbol: null,
        name: null,
        sort: null,
        attachmentRequired: null,
        active: null,
        modifiedBy: null,
        modifiedOn: null
    }],
    report: {
        absence: {
            list: [],
            updatedOn: null
        },
        hours: [],
        year: null
    },
    limits: {
        userID: null,
        baseDays: null,
        outstandingDays: null,
        currentDays: null,
        totalDays: null,
        usedDays: null,
        remainingOutstandingDays: null,
        remainingCurrentDays: null,
        remainingDays: null,
        remainingOnRequest: null,
        usedOnRequest: null,
        createdOn: null
    }
};

const absenceReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_ABSENCE_REASONS:
            return {
                ...state,
                reasons: action.payload.list.map(absence => {
                    return {
                        absenceID: absence.absenceID,
                        code: absence.code,
                        symbol: absence.symbol,
                        name: absence.name,
                        sort: absence.sort,
                        attachmentRequired: absence.attachmentRequired,
                        active: absence.active,
                        modifiedBy: absence.modifiedBy,
                        modifiedOn: absence.modifiedOn
                    };
                })
            };
        case SET_ABSENCE_LIST:
            return {
                ...state,
                report: {
                    ...state.report,
                    absence: {
                        list: action.payload.list.map(absence => {
                            return {
                                absenceNo: absence.absenceNo,
                                absenceID: absence.absenceID,
                                absenceName: absence.absenceName,
                                userID: absence.userID,
                                dateFrom: absence.dateFrom,
                                dateTo: absence.dateTo,
                                dayCount: absence.dayCount,
                                createdOn: absence.createdOn
                            };
                        }),
                        updatedOn: action.payload.updatedOn,
                    },
                    year: action.payload.year
                }
            };
        case SET_ABSENCE_HOURS_LIST:
            return {
                ...state,
                report: {
                    ...state.report,
                    hours: action.payload.list.map(hours => {
                        return {
                            absenceNo: hours.absenceNo,
                            absenceID: hours.absenceID,
                            absenceName: hours.absenceName,
                            userID: hours.userID,
                            dateFrom: hours.dateFrom,
                            timeFrom: hours.timeFrom,
                            dateTo: hours.dateTo,
                            timeTo: hours.timeTo
                        };
                    }),
                    year: action.payload.year
                }
            };
        case SET_ABSENCE_LIMITS:
            return {
                ...state,
                limits: {
                    userID: action.payload.userID,
                    baseDays: action.payload.baseDays,
                    outstandingDays: action.payload.outstandingDays,
                    currentDays: action.payload.currentDays,
                    totalDays: action.payload.totalDays,
                    usedDays: action.payload.usedDays,
                    remainingOutstandingDays: action.payload.remainingOutstandingDays,
                    remainingCurrentDays: action.payload.remainingCurrentDays,
                    remainingDays: action.payload.remainingDays,
                    remainingOnRequest: action.payload.remainingOnRequest,
                    usedOnRequest: action.payload.usedOnRequest,
                    createdOn: action.payload.createdOn
                }
            };
        case LOGOUT:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default absenceReducer;